// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"fp-z","badgeLink":"gp-z","category":"hp-z"};